<svg
  id="Layer_1"
  data-name="Layer 1"
  viewBox="3.5 6 58 58"
  aria-labelledby="exclamation-warning-icon-title exclamation-warning-icon-desc"
  role="img"
>
  <title id="exclamation-warning-icon-title">Warning icon</title>
  <desc id="exclamation-warning-icon-desc">An icon with a red triangle with a white exclamation mark depicting a warning.</desc>
  <path
    fill="#cf000e"
    class="fill"
    d="M27.67,9.29,4.33,49.71a5,5,0,0,0,4.33,7.5H55.34a5,5,0,0,0,4.33-7.5L36.33,9.29A5,5,0,0,0,27.67,9.29Z"
  />
  <path
    fill="#fff"
    class="stroke"
    d="M32,42.88a3.44,3.44,0,0,1,2.5.92,3.33,3.33,0,0,1,0,4.66,3.83,3.83,0,0,1-5,0,3.05,3.05,0,0,1-1-2.32,3.09,3.09,0,0,1,1-2.33A3.39,3.39,0,0,1,32,42.88Zm.62-3.37H31.37a2,2,0,0,1-2-1.93l-.59-17.5a2,2,0,0,1,2-2.07H33.2a2,2,0,0,1,2,2.07l-.59,17.5A2,2,0,0,1,32.61,39.51Z"
  />
</svg>
